import { getRouteApi, useNavigate } from '@tanstack/react-router';
import GoBackHeader from '@emfood/shared/src/components/go-back-header/go-back-header';
import {
  ACHelmetContainer,
  createPaginationSchema,
  useSyncTableSearchParams,
  getTableModelsFromSearchParams,
} from '@emfood/shared';

import { Card, Stack, Typography, Pagination, CardContent, CardActionArea } from '@mui/material';

import { paths } from 'src/routes/paths';

import { useNewsPostsList } from 'src/hooks/use-news-list';

import { useSettingsContext } from 'src/components/settings';
import { LoadingBarHorizontal } from 'src/components/loading';

export const NewsPostsListSearchParamsSchema = createPaginationSchema();

const routeApi = getRouteApi('/news/');

export default function NewsPostsList() {
  const settings = useSettingsContext();
  const navigate = useNavigate();

  const routeNavigate = routeApi.useNavigate();
  const routeSearch = routeApi.useSearch();

  const { paginationModel: searchPaginationModel } = getTableModelsFromSearchParams(routeSearch);

  const {
    newsPosts,
    fetchNewsPostsLoading,
    paginationModel,
    setPaginationModel,
    newsPostsTotalPages,
  } = useNewsPostsList({
    initialPaginationModel: searchPaginationModel,
  });

  useSyncTableSearchParams({ navigate: routeNavigate, paginationModel });

  return (
    <ACHelmetContainer maxWidth={settings.themeStretch ? false : 'xl'} title="News Posts">
      <GoBackHeader heading="News Posts" disableGoBack />
      <LoadingBarHorizontal showLoading={fetchNewsPostsLoading} />
      {newsPosts.length > 0 ? (
        <>
          <Stack spacing={2}>
            {newsPosts &&
              newsPosts.map((post) => (
                <Card key={post.id}>
                  <CardActionArea
                    onClick={() => navigate({ to: paths.dashboard.news.detail(post.id) })}
                  >
                    <CardContent>
                      <Typography variant="h2">{post.name}</Typography>
                      {post.publishedByName && (
                        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
                          by {post.publishedByName}
                        </Typography>
                      )}
                      <Typography variant="subtitle2">{`Published on ${new Date(post.lastPublishedAt).toLocaleString()}`}</Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              ))}
          </Stack>
          <Pagination
            count={newsPostsTotalPages}
            page={paginationModel.page + 1}
            onChange={(_event, page) => {
              setPaginationModel((prevModel) => ({ ...prevModel, page: page - 1 }));
            }}
            sx={{ marginTop: 2 }}
          />
        </>
      ) : (
        <Typography>No posts are available at this time.</Typography>
      )}
    </ACHelmetContainer>
  );
}
